import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updatePreApprovalLoan } from "../pre-approval-loan-wrapper/actions";
import { startPreApprovalOnFly } from "../../pre-approval-on-fly-modal/actions";
import FinancingCfRejected from "./component";

const mapStateToProps = ({
    preApprovalLoan: {
        financeData,
        financeErrorResponse,
        inHouseFinanceEligibility
    },
    abExperiment: {
        preApprovalOnFlyDesktop
    }
}) => ({
    financeData,
    financeErrorResponse,
    inHouseFinanceEligibility,
    preApprovalOnFlyDesktop
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updatePreAppovalLoanConnect: updatePreApprovalLoan,
    startPreApprovalOnFlyConnect: startPreApprovalOnFly
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FinancingCfRejected);
